module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (this.styleObject)
  }, [(_vm.devices.length > 1) ? _c('a', {
    staticClass: "device-switcher icon yule-icon-refresh btn btn-rounded",
    on: {
      "click": _vm.switchDevice
    }
  }) : _vm._e(), _vm._v(" "), (this.streamIsPresent) ? _c('video', {
    ref: "video",
    attrs: {
      "width": this.width,
      "height": this.height,
      "autoplay": this.autoplay
    },
    domProps: {
      "srcObject": this.stream
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2856e254","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/VueWebcam.vue
// module id = 1847
// module chunks = 0